export default __webpack_public_path__ + "./image/00ac7af53e61a40259624cb94d6fefaf.png";